import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import Layout from '../../components/Layout';
import ReversalQueueTab from './ReversalQueueTab';
import PendingReversalsTab from './PendingReversalsTab';
import './styles.css';

const { TabPane } = Tabs;

const ReversalOpsManagement = () => {
  const [activeTab, setActiveTab] = useState('queue');

  return (
    <Layout>
      <div className="reversal-container">
        <Card 
          title={<span style={{ fontSize: '18px', fontWeight: 600, color: '#1f1f1f' }}>Admin Reversal Operations</span>}
          bordered={false}
          style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)' }}
        >
          <Tabs defaultActiveKey="queue" activeKey={activeTab} onChange={setActiveTab} size="large">
            <TabPane tab="CBA Reversal Queue" key="queue">
              {activeTab === 'queue' && <ReversalQueueTab />}
            </TabPane>
            <TabPane tab="Pending Approvals" key="pending">
              {activeTab === 'pending' && <PendingReversalsTab />}
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </Layout>
  );
};

export default ReversalOpsManagement;
